import { CLEAR_STORE, SET_BOMID, SET_IS_CUSTOMQUOTE_REQUIRES, SET_RFQ_DETAILS, SET_EXTERNAL_USERID } from '../../constants/ActionConstants';

const InitialState = {};
export const RFQDetails = (state = InitialState, action) => {
    const { type, data } = action;

    switch (type) {
        case SET_RFQ_DETAILS:
            return { ...state, rfqDetails: data.rfqDetails };
        case SET_BOMID:
            return { ...state, bomId: data.bomId };
        case SET_IS_CUSTOMQUOTE_REQUIRES:
            return { ...state, isCustomQuoteRequires: data.isCustomQuoteRequires };
        case SET_EXTERNAL_USERID:
            return { ...state, externalUserId: data.externalUserId };
        case CLEAR_STORE:
            return InitialState;
       default:
            return state;
    }
}